// import React from 'react';
import { Smartphone, Zap, Activity } from 'lucide-react';

export const Features = () => (
    <section id="features" style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-secondary)', position: 'relative' }}>
        <div className="container">
            <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                    The 4 Pillars of Modern Service.
                </h2>
                <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                    Everything required to unify your staff and your guests into a seamless hospitality ecosystem.
                </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '32px' }}>
                <div className="glass-panel" style={{ padding: '48px', overflow: 'hidden', position: 'relative', border: '1px solid var(--border-focus)' }}>
                    <div style={{ position: 'absolute', top: 0, right: 0, width: '250px', height: '250px', background: 'var(--accent-primary)', filter: 'blur(100px)', opacity: 0.15, borderRadius: '50%', transform: 'translate(30%, -30%)', zIndex: -1 }}></div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
                        <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '16px', borderRadius: '12px' }}>
                            <Smartphone size={32} color="var(--accent-primary)" />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 600 }}>Customer Experience</h3>
                    </div>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '32px' }}>Scan &rarr; View &rarr; Call/Pay.</p>
                    <div style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <img src="/customer_experience.png" alt="Customer Experience" style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }} />
                    </div>
                </div>

                <div className="glass-panel" style={{ padding: '48px', overflow: 'hidden', position: 'relative', border: '1px solid var(--border-focus)' }}>
                    <div style={{ position: 'absolute', top: 0, right: 0, width: '250px', height: '250px', background: 'var(--accent-secondary)', filter: 'blur(100px)', opacity: 0.15, borderRadius: '50%', transform: 'translate(30%, -30%)', zIndex: -1 }}></div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
                        <div style={{ background: 'rgba(139, 92, 246, 0.1)', padding: '16px', borderRadius: '12px' }}>
                            <Zap size={32} color="var(--accent-secondary)" />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 600 }}>Staff Optimization</h3>
                    </div>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '32px' }}>Real-time task dispatching to natively built mobile apps.</p>
                    <div style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <img src="/staff_experience.png" alt="Staff Experience" style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }} />
                    </div>
                </div>

                <div className="glass-panel" style={{ padding: '48px', overflow: 'hidden', position: 'relative', border: '1px solid var(--border-focus)' }}>
                    <div style={{ position: 'absolute', top: 0, right: 0, width: '250px', height: '250px', background: '#10B981', filter: 'blur(100px)', opacity: 0.1, borderRadius: '50%', transform: 'translate(30%, -30%)', zIndex: -1 }}></div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
                        <div style={{ background: 'rgba(16, 185, 129, 0.1)', padding: '16px', borderRadius: '12px' }}>
                            <Activity size={32} color="#10B981" />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 600 }}>Manager Intelligence</h3>
                    </div>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '32px' }}>Live dashboards, table heatmaps, and staff performance analytics.</p>
                    <div style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <img src="/establishment_experience.png" alt="Establishment Experience" style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }} />
                    </div>
                </div>

            </div>
        </div>
    </section>
);
